export default __webpack_public_path__ + "img/forecast.1444a9.svg";